import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { init } from '../../../../actions/login'


const mapStateToProps = createStructuredSelector({})

const mapDispatchToProps = dispatch => {
    return {
        init: (loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl) => dispatch(init(loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
